import { render } from "./GraphCuration.vue?vue&type=template&id=5e656dad&scoped=true"
import script from "./GraphCuration.vue?vue&type=script&lang=js"
export * from "./GraphCuration.vue?vue&type=script&lang=js"

import "./GraphCuration.vue?vue&type=style&index=0&id=5e656dad&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e656dad"]])

export default __exports__